<template>
  <hm-content :hidden="hidden">
    <div class="table-panel flex flex-end">
      <el-input
        style="width:280px"
        clearable
        v-model.trim="searchCondition.keyWords"
        :placeholder="placeholder"
        size="small"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          style="width:100px"
          v-model="searchCondition.queryType"
          @change="selectQueryType"
          size="small"
        >
          <el-option label="订单号" value="orderSn"></el-option>
          <el-option label="分佣单号" value="commissionSn"></el-option>
          <el-option label="分销人" value="shareName"></el-option>
          <el-option label="电话" value="sharePhone"></el-option>
        </el-select>
      </el-input>
      <el-select
        clearable
        v-model="searchCondition.shopId"
        placeholder="搜索/选择门店"
        size="small"
        filterable
        class="mr10"
      >
        <el-option
          :label="v.shopName"
          :value="v.shopId"
          v-for="(v, i) in shopList"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.commissionLevel"
        placeholder="请选择佣金级别"
        filterable
        size="small"
        class="mr10"
      >
        <el-option label="1级分销" value="1"></el-option>
        <el-option label="2级分销" value="2"></el-option>
        <el-option label="3级分销" value="3"></el-option>
        <el-option label="4级分销" value="4"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.commissionState"
        placeholder="请选择佣金状态"
        filterable
        size="small"
        class="mr10"
      >
        <el-option label="锁定" value="lock"></el-option>
        <el-option label="可用" value="use"></el-option>
        <el-option label="退款" value="returnOrder"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.sendCommissionMode"
        placeholder="请选择佣金发放类型"
        filterable
        size="small"
        class="mr10"
      >
        <el-option label="自发佣金" value="oneself"></el-option>
        <el-option label="代发佣金" value="hemiao"></el-option>
      </el-select>
      <el-date-picker
        :default-time="['00:00:00', '23:59:59']"
        class="mr10"
        size="small"
        style="width:340px"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="searchCondition.date"
        type="datetimerange"
        range-separator="至"
        start-placeholder="请选择分销时间段"
        end-placeholder="请选择分销时间段"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="info" size="small" @click="searchCondition = {}"
        >重置</el-button
      >
      <el-button type="success" size="small" @click="dialogVisibleOutput = true"
        >生成报表</el-button
      >
      <!-- <el-button
        type="success"
        size="small"
        @click="output('queryAllList', '分佣流水')"
        :loading="isOutputing"
        >导出</el-button
      > -->
    </div>
    <div class="flex flex-start mb10">
      <el-radio-group
        v-model="searchCondition.commissionType"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="all">全部</el-radio-button>
        <el-radio-button label="share">分销佣金</el-radio-button>
        <el-radio-button label="agent">代理奖励</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="Level"
          label="佣金级别"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.commissionType === 'agent'">
              代理奖励
            </div>
            <div v-else>{{ scope.row.Level }}级分销</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendCommissionMode"
          label="佣金发放类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sendCommissionMode === 'oneself'">
              自发佣金
            </div>
            <div v-else>代发分销</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="所属门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="订单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareName"
          label="分销会员"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sharePhone"
          label="电话号码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payPrice"
          label="订单金额"
        >
          <template slot-scope="scope">
            <span class="primary">{{ scope.row.payPrice }}元</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="payTime"
          header-align="center"
          align="center"
          label="付款时间"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="commissionMoney"
          label="返佣金额"
        >
          <template slot-scope="scope">
            <span class="primary">{{ scope.row.commissionMoney }}元</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="commissionState"
          label="佣金状态"
        >
          <template slot-scope="scope">
            <div
              :class="[
                scope.row.commissionState === 'lock' ? 'danger' : 'success'
              ]"
              v-if="scope.row.commissionState === 'lock'"
            >
              锁定
            </div>
            <div
              :class="[
                scope.row.commissionState === 'lock' ? 'danger' : 'success'
              ]"
              v-if="scope.row.commissionState === 'use'"
            >
              可用
            </div>
            <div
              class="danger"
              v-if="scope.row.commissionState === 'returnOrder'"
            >
              退款
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="details(scope.row)"
                >订单详情</el-button
              >
            </div>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="empty">
            <img class="img_no" src="../../assets/n001.jpg" alt="">
            <p class="empty_tex">请设置查询条件后查询</p>
          </div>
        </template>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="详情"
      width="1200px"
      :visible.sync="dialogVisible">
      <div class="content">
        <ul class="info-list">
          <li class="mb20 flex flex-wrap" style="color: #222;">
            <div class="mr20">
              佣金类型:<span>{{ row.Level }}级返佣</span>
            </div>
            <div class="ml20">
              佣金状态:
              <span v-if="row.commissionState === 'lock'" class="danger"
                >锁定</span
              >
              <span v-if="row.commissionState === 'use'" class="success"
                >可用</span
              >
              <span v-if="row.commissionState === 'returnOrder'" class="danger"
                >退款</span
              >
            </div>
          </li>
          <li class="mb20">
            <div class="title">
              基本信息
            </div>
            <div class="mb20">
              <div class="modal-table mb20">
                <div class="table-header flex">
                  <div class="flex-1">订单号</div>
                  <div class="flex-1">会员手机号</div>
                  <div class="flex-1">订单来源</div>
                  <div class="flex-1">订单类型</div>
                </div>
                <div class="table-body flex">
                  <div class="flex-1">{{ row.orderSn }}</div>
                  <div class="flex-1">
                    {{ row.sharePhone }}
                  </div>
                  <div class="flex-1">
                    微店订单
                  </div>
                  <div class="flex-1">
                    微店订单
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="mb20">
            <div class="title">
              商品信息
            </div>
            <div class="mb20 detail">
              <el-table
                :header-cell-style="{ background: '#f7f7f7', color: '#222' }"
                stripe
                ref="table"
                :data="orderDetails"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsImg"
                  label="商品图片"
                >
                  <template slot-scope="scope">
                    <div>
                      <img
                        style="width:100px;height:100px;"
                        v-if="scope.row.goodsImg"
                        :src="scope.row.goodsImg"
                        alt=""
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="商品名称/品牌"
                >
                  <template slot-scope="scope">
                    <p>{{ scope.row.spuName }}</p>
                    <p>品牌: {{ scope.row.brandName }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="价格/货号"
                >
                  <template slot-scope="scope">
                    <p>价格: {{ scope.row.totalPrice }}</p>
                    <p>货号: {{ scope.row.goodsSn }}</p>
                    <p>条码: {{ scope.row.barCode }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="净重/毛重"
                >
                  <template slot-scope="scope">
                    <p v-if="scope.row.netWeight">
                      净重: {{ scope.row.netWeight }}
                    </p>
                    <p v-if="scope.row.grossWeight">
                      毛重: {{ scope.row.grossWeight }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="specIdGroupName"
                  label="规格"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsNum"
                  label="数量"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalPrice"
                  label="小计"
                >
                  <template slot-scope="scope">
                    <p>￥{{ scope.row.totalPrice * scope.row.goodsNum }}</p>
                  </template>
                </el-table-column>

                <el-table-column
                  header-align="center"
                  align="center"
                  prop="commissionMoney"
                  label="佣金"
                >
                  <template slot-scope="scope">
                    <div class="primary">{{ scope.row.commissionMoney }}元</div>
                  </template>
                </el-table-column>

                <el-table-column
                  header-align="center"
                  align="center"
                  prop="commissionState"
                  label="佣金状态"
                >
                  <template slot-scope="scope">
                    <div
                      class="gray"
                      v-if="scope.row.commissionState === 'lock'"
                    >
                      锁定
                    </div>
                    <div
                      class="danger"
                      v-if="scope.row.commissionState === 'returnOrder'"
                    >
                      退款
                    </div>
                    <div
                      class="success"
                      v-if="scope.row.commissionState === 'use'"
                    >
                      可用
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="total-price flex flex-end">
                佣金总计：<span class="primary mr10"
                  >{{ commissionTotalMoney }}元</span
                >
              </div>
            </div>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="dialogVisible = false" size="small" type="primary">
            关 闭</el-button
          >
        </span>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="生成报表"
      :visible.sync="dialogVisibleOutput"
    >
      <div class="flex flex-center">
        <el-select
          clearable
          v-model="searchOutputCondition.commissionState"
          placeholder="请选择佣金状态"
          filterable
          size="small"
          class="mr10"
        >
          <el-option label="锁定" value="no"></el-option>
          <el-option label="可用" value="orderHandle"></el-option>
          <el-option label="退款" value="returnOrder"></el-option>
        </el-select>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchOutputCondition.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择分销时间段"
          end-placeholder="请选择分销时间段"
        ></el-date-picker>
        <el-button type="success" size="small" @click="output"
          >生成报表</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      hidden: true,
      dialogVisibleOutput: false,
      dialogVisible: false,
      isOutputing: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      searchCondition: {
        commissionType: "all",
        queryType: "orderSn",
        date: []
      },
      searchOutputCondition: {},
      placeholder: "请输入订单号",
      orderDetails: [],
      row: {},
      commissionTotalMoney: 0,
      shopList: []
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    // if (this.$route.query.time) {
    //   this.searchCondition.date = JSON.parse(this.$route.query.time);
    // }
    // this.queryList();
    // this.queryShopList();
    const startTime = moment()
      .subtract(3, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.date = [startTime, endTime];
    this.queryList();
  },
  methods: {
    async queryShopList() {
      const { code, result } = await this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999
      });
      if (code === "0") {
        this.shopList = result.records;
      }
    },
    selectQueryType(queryType) {
      if (queryType === "orderSn") {
        this.placeholder = "请输入订单号";
      } else if (queryType === "commissionSn") {
        this.placeholder = "请输入分佣单号";
      } else if (queryType === "shareName") {
        this.placeholder = "请输入分销人";
      } else if (queryType === "sharePhone") {
        this.placeholder = "请输入电话";
      }
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.shareStartDate = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.shareEndDate = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";
      searchCondition.commissionType =
        searchCondition.commissionType === "all"
          ? ""
          : searchCondition.commissionType;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryShareAgentFlowList",
        params
      );
      const { records, total } = result;
      records.forEach(v => {
        v.Level = this.SectionToChinese(v.commissionLevel);
      });
      this.list = records;
      this.total = total;
    },
    async queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.shareStartDate = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.shareEndDate = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";
      searchCondition.commissionType =
        searchCondition.commissionType === "all"
          ? ""
          : searchCondition.commissionType;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryShareAgentFlowAllList",
        params
      );
      const { records } = result;
      return records;
    },
    SectionToChinese(section) {
      let chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九"
      ];
      let chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
      let strIns = "",
        chnStr = "";
      let unitPos = 0;
      let zero = true;
      while (section > 0) {
        let v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },
    async details(row) {
      this.dialogVisible = true;
      this.row = row;
      const { result } = await this.$store.dispatch(
        "queryDetailsShareAgentFlow",
        {
          orderSn: row.orderSn,
          obtainCommissionId: row.obtainCommissionId,
          commissionType: row.commissionType
        }
      );
      let total = 0;
      result.map(v => {
        if (v.commissionState !== "returnOrder") {
          total += v.commissionMoney;
        }
      });
      this.orderDetails = result;
      this.commissionTotalMoney = total.toFixed(2);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    output() {
      if (this.isArray(this.searchOutputCondition.date)) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchOutputCondition)
        );
        searchCondition.shareStartDate =
          this.searchOutputCondition.date &&
          this.searchOutputCondition.date.length > 0
            ? this.searchOutputCondition.date[0]
            : "";
        searchCondition.shareEndDate =
          this.searchOutputCondition.date &&
          this.searchOutputCondition.date.length > 0
            ? this.searchOutputCondition.date[1]
            : "";
        this.$store.dispatch("exportFlowDetailsList", searchCondition);

        this.$message({
          message: "已加入导出队列，请在导出列队中查看！",
          type: "success"
        });
        setTimeout(() => {
          this.hidden = false;
        }, 0);

        this.dialogVisibleOutput = false;
        this.searchOutputCondition = {};
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    // 导出excel
    // output(funcName, title) {
    //   require.ensure([], () => {
    //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
    //     this.isOutputing = true;
    //     const func = this[funcName];
    //     func()
    //       .then(res => {
    //         const list = res;
    //         list.forEach(v => {
    //           v.Level = this.SectionToChinese(v.commissionLevel) + "级分销";
    //           v.commissionState =
    //             v.commissionState === "lock" ? "锁定" : "可用";
    //         });
    //         const tHeader = this.$refs.table.columns
    //           .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
    //           .filter(o => o);
    //         let filterVal = [];
    //         if (list.length > 0) {
    //           filterVal = this.$refs.table.$children
    //             .map(o => o._props.prop)
    //             .filter(o => o);
    //         }
    //         const data = this.formatJson(filterVal, list);
    //         exportJsonToExcel(
    //           tHeader,
    //           data,
    //           title + new Date().toLocaleString()
    //         );
    //         this.isOutputing = false;
    //       })
    //       .catch(() => {
    //         this.isOutputing = false;
    //       });
    //   });
    // },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss">
.detail {
  .el-table {
    border: 1px solid #ebeef5;
    border-bottom: none;
  }
}
</style>
<style lang="scss" scoped>
.info-list {
  .title {
    color: rgba(34, 34, 34, 1);
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    font-weight: bold;
    background: #f7f7f7;
    > div {
      padding: 15px;
      color: #222;
    }
  }
  .table-body {
    > div {
      padding: 15px;
    }
  }
}
.total-price {
  color: #222222;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ebeef5;
  border-top: none;
}

.empty {
  width: 100%;
  box-sizing: border-box;
  padding-top: 40px;
  .empty_tex {
    font-size: 18px;
    color: #666666;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    padding: 0;
  }
}
</style>
